import {
  Box,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import {SupportTicketTypeEnum} from '../../../../model/support/support-ticket-type.enum';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {SupportTicketUtils} from '../utils/support-ticket.utils';

type Props = {
  ticket: SupportTicketModel
  setTicket: (ticket: SupportTicketModel) => void
  translate: (key: string) => string
  translateLocal: (key: string) => string
  isEditDisabled: boolean
}

export const SupportTicketDrawerClassification = ({ticket, setTicket, translate, isEditDisabled, translateLocal}: Props) => {
  const buildHeader = () => (
    <Box mt={1} pt={1}>
      <Box display="flex" alignItems="center" ml={0.5} mb={0.5}>
        <Typography variant="body1" fontWeight={600} letterSpacing={1} mr={1} lineHeight={1}>
          Klasyfikacja zgłoszenia:
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
    </Box>
  )

  const translateOption = (value: string) => translate(`support.ticket.resolution.${value}.option`)

  const buildClassifiedTypeSelect = () => (
    <FormControl fullWidth>
      <InputLabel shrink>{translateLocal('ticket.drawer.classifiedType')}</InputLabel>
      <Select
        displayEmpty
        disabled={isEditDisabled}
        label={translateLocal('ticket.drawer.classifiedType')}
        value={ticket.classifiedType}
        onChange={(e) => setTicket({ ...ticket, classifiedType: e.target.value as SupportTicketTypeEnum, classifiedErrorType: e.target.value === 'ERROR' ? ticket.classifiedErrorType : null })}
        sx={{
          py: 0.4,
          '& .MuiSelect-select': {
            py: 0.9,
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-displayEmpty': {
            color: (theme) => theme.palette.text.disabled,
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <MenuItem value="ERROR">{translate('support.ticket.type.ERROR')}</MenuItem>
        <MenuItem value="IMPROVEMENT">{translate('support.ticket.type.IMPROVEMENT')}</MenuItem>
      </Select>
    </FormControl>
  );

  const buildErrorTypeInput = () => (
    <FormControl fullWidth>
      <InputLabel shrink>{translateLocal('ticket.drawer.classifiedErrorType')}</InputLabel>
      <Select
        disabled={ticket.classifiedType === 'IMPROVEMENT' || isEditDisabled}
        displayEmpty
        label={translateLocal('column.classifiedErrorType')}
        value={ticket.classifiedErrorType || ''}
        onChange={(e) => setTicket({ ...ticket, classifiedErrorType: e.target.value })}
        sx={{
          py: 0.4,
          '& .MuiSelect-select': {
            py: 0.9,
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-displayEmpty': {
            color: (theme) => theme.palette.text.disabled,
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <MenuItem value="CRITICAL_ERROR">{translate('support.ticket.error_type.CRITICAL_ERROR')}</MenuItem>
        <MenuItem value="MAJOR_ERROR">{translate('support.ticket.error_type.MAJOR_ERROR')}</MenuItem>
        <MenuItem value="OTHER_ERROR">{translate('support.ticket.error_type.OTHER_ERROR')}</MenuItem>
        <MenuItem value="UPDATE_ERROR">{translate('support.ticket.error_type.UPDATE_ERROR')}</MenuItem>
      </Select>
    </FormControl>
  );

  return <>
    {buildHeader()}
    <Stack direction="row" spacing={2} mb={2} mt={1}>
      <Stack sx={{ flex: 1 }}>{buildClassifiedTypeSelect()}</Stack>
      {
        ticket.classifiedType === 'ERROR'
          ? <Stack sx={{ flex: 1 }}>{buildErrorTypeInput()}</Stack>
          : <></>
      }
    </Stack>
  </>
}